import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { DOWNLOAD_ASYNC_JOB_FILE } from '../types';
import {
  downloadAsyncJobFilePending,
  downloadAsyncJobFileFulfilled,
  downloadAsyncJobFileRejected } from '../actions';

import { sendApiRequest, notifyError, notifyWarning } from '../../../actions';

import { GET_ASYNC_JOBS_MESSAGES } from '../constants/organizationMessages'
import generateError from '../../../utilities/generateError';

const createPayload = payload => ({
  method: 'get',
  url: 'asyncjobs/GetResultData/'+payload,
  onSuccess: [response => (response.data.length === 0
    ? notifyWarning(GET_ASYNC_JOBS_MESSAGES.NOT_FOUND)
    : downloadAsyncJobFileFulfilled(response))],
  onError: [
    downloadAsyncJobFileRejected,
    error => notifyError(generateError(error)),
  ],
});

const meta = {
  api: 'pdfApi',
};

const downloadAsyncJobFileEpic$ = (action$, state$) => action$.pipe(
  ofType(DOWNLOAD_ASYNC_JOB_FILE.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => {
    return merge(
      of(downloadAsyncJobFilePending()),
      of(sendApiRequest(createPayload(payload), meta)),
    );
  }),
);

export default downloadAsyncJobFileEpic$;


// WEBPACK FOOTER //
// ./src/features/organization/epics/downloadAsyncJobFileEpic.js